import AdyenCheckoutError from '@adyen/adyen-web/dist/types/core/Errors/AdyenCheckoutError'
import { AdyenResultStatus } from '@customTypes/adyenResultStatus.enum'
import createAdyenCheckout from '@utils/createAdyenCheckout.utils'
import { useEffect } from 'react'

export const useGetPaymentData = (
    sessionId: string,
    redirectResult: string,
    onPaymentCompleted: (resultCode: AdyenResultStatus) => void,
    onPaymentError: (error: AdyenCheckoutError) => void
) => {
    useEffect(() => {
        const getPaymentData = async () => {
            const adyenCheckout = await createAdyenCheckout(
                { id: sessionId },
                (result) => onPaymentCompleted(result.resultCode as AdyenResultStatus),
                onPaymentError
            )
            adyenCheckout.submitDetails({ details: { redirectResult } })
        }
        if (sessionId && redirectResult) {
            getPaymentData()
        }
    }, [sessionId, redirectResult, onPaymentCompleted, onPaymentError])
}
